module.exports = '<svg width="44" height="32" viewBox="0 0 44 32"><path d="M36.949 12.294h-.229C35.525 4.904 29.473 0 22.17 0 14.849 0 8.787 4.904 7.612 12.294H7.39c-4.325 0-7.39 5.2-7.39 9.853C0 27.566 4.409 32 9.853 32h24.632c5.444 0 9.804-4.409 9.804-9.828 0-4.582-3.104-9.878-7.34-9.878zm-5.033 2.247L20.972 25.559a1.09 1.09 0 0 1-1.549 0l-6.569-6.611a1.11 1.11 0 0 1 0-1.559l1.549-1.559a1.09 1.09 0 0 1 1.547 0l4.249 4.274 8.626-8.68a1.09 1.09 0 0 1 1.547 0l1.547 1.559a1.109 1.109 0 0 1-.002 1.559z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/cloud-checkmark-1.js
// module id = 1075
// module chunks = 14